import EOPTooltip, { type EOPTooltipProps } from './EOPTooltip';

export type { EOPTooltipProps };
export default EOPTooltip;
